
export class Person {
  public id: string;
  public name: string;
  public reachable: string;
  public status: string;
  public info: string;
  public version: number;
  public displayName: string;
  // 48x48 pixel avatar-image as base64-string
  public avatarImage: string;

  constructor(id: string, displayName: string, name: string, avatarImage: string,
    reachable: string, status: string, info: string) {
    this.id = id;
    this.name = name;
    this.reachable = reachable;
    this.status = status;
    this.info = info;
    this.displayName = displayName;
    this.avatarImage = avatarImage;
  }

  // TODO we are directly mapping jira-fields here. This should be transparent to the client and done on pyWall instead. DZ 02/20
  public static createFromPywallData(data): Person {
    if (!data) {
      return null;
    }

    const id = (data['id']) ? data['id'] : data['key'];
    const name = data['name'];
    const displayName = data['displayName'];
    const status = data['status'];
    const reachable = (data['reachable']) ? data['reachable'] : '';
    const info = (data['info']) ? data['info'] : '';
    const avatarImage = (data['avatarImage']) ? data['avatarImage'] : '';


    return new Person(id, displayName, name, avatarImage, reachable, status, info);
  }

}

